import { Link } from "react-router-dom";

export default function Footer({ variant = "light" }) {
  const tone = variant === "dark" ? "text-stone-400" : "text-stone-500";
  return (
    <footer className={`mt-16 py-6 text-center text-[11px] font-[Manrope] tracking-wide ${tone}`}>
      <span>© 2026 Aynora</span>
      <span className="mx-2">·</span>
      <Link to="/privacy" className="hover:text-[#6B7A54] transition-colors">Privacy</Link>
      <span className="mx-2">·</span>
      <Link to="/terms" className="hover:text-[#6B7A54] transition-colors">Terms</Link>
      <span className="mx-2">·</span>
      <Link to="/refunds" className="hover:text-[#6B7A54] transition-colors">Refunds</Link>
      <span className="mx-2">·</span>
      <Link to="/contact" className="hover:text-[#6B7A54] transition-colors">Contact</Link>
    </footer>
  );
}
